/**
 * Portal Entry Point for Workforce Scheduling
 *
 * This file registers all pages with the portal system.
 * It is imported by the portal's virtual:portal-entries module.
 */

import { registerFieldComponent, registerTabComponent } from "@ja/crud/services/componentRegistry";
import { registerPage } from "@ja/portal/pageRegistry";

// CRUD custom field types
registerFieldComponent(
    "stepsEditor",
    () => import("./Components/CrudStepsEditorField.vue"),
    "scheduling"
);

// Admin pages
registerPage(
    "scheduling",
    "Base/Admin/WeekView",
    () => import("./Pages/Admin/WeekView.vue")
);

registerPage(
    "scheduling",
    "Base/Admin/CopyWeek",
    () => import("./Pages/Admin/CopyWeek.vue")
);

// CRUD custom tab for embedding user schedules in editor/viewer
registerTabComponent(
    "Scheduling::UserScheduleTab",
    () => import("./Components/UserScheduleTab.vue"),
    "scheduling"
);

